import { useState, useEffect } from "react";
import { KEYBOARD_KEYS } from "const";
import CloseIcon from "@mui/icons-material/Close";
import { TextField } from "@mui/material";
import ButtonRed from "components/utils/CustomFields/ButtonRed";
import ButtonGray from "components/utils/CustomFields/ButtonGray";
import styles from "./styles.module.css";
import toast from "react-hot-toast";

export default function CartDeleteConfirmPopup({ open, onClose, onConfirm }) {
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (open) {
      setDescription("");
    }
  }, [open]);

  if (!open) return null;

  const handleConfirm = () => {
    if (!description) {
      toast.error("Please provide reason");
      return;
    }
    onConfirm?.(description.trim());
  };

  const handleKeyDown = (e) => {
    if (e.key === KEYBOARD_KEYS.ENTER) {
      e.preventDefault();
      handleConfirm();
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  return (
    <div className={styles.popUp} onClick={handleBackdropClick}>
      <div className={styles.contentWrapper} onClick={(e) => e.stopPropagation()}>
        <div className={styles.headInfoSec}>
          <h3>Delete Order</h3>
          <CloseIcon className={styles.icon} onClick={onClose} />
        </div>

        <div className={styles.contentArea}>
          <div className={styles.subTitle}>
            Are you sure you want to delete this order? This action cannot be undone.
          </div>
          <TextField
            autoFocus
            margin="dense"
            label="Reason / Description"
            placeholder="Enter reason for deleting this cart"
            type="text"
            fullWidth
            multiline
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            onKeyDown={handleKeyDown}
            variant="outlined"
            sx={{
              mt: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
              },
            }}
          />
        </div>

        <div className={styles.buttonSection}>
          <ButtonGray onClick={onClose}>Cancel</ButtonGray>
          <ButtonRed onClick={handleConfirm}>Delete</ButtonRed>
        </div>
      </div>
    </div>
  );
}
